import { render } from "./NextOfKinPopup.vue?vue&type=template&id=27e862b0"
import script from "./NextOfKinPopup.vue?vue&type=script&lang=js"
export * from "./NextOfKinPopup.vue?vue&type=script&lang=js"

import "./NextOfKinPopup.vue?vue&type=style&index=0&id=27e862b0&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__